function NicknameOptions({ values, onChange }) {
  const setAt = (idx, v) => {
    const next = [...values];
    next[idx] = v;
    onChange(next);
  };

  const placeholders = ['Primera opción (preferida)', 'Segunda opción', 'Tercera opción'];

  return (
    <div className="tm-reg-nicks">
      <div className="tm-reg-nicks-header">
        <p className="tm-reg-nicks-title">
          <span className="tm-reg-nicks-at">@</span> Opciones de Nick <span className="tm-reg-required">*</span>
        </p>
        <p className="tm-reg-nicks-hint">
          Ingresa 3 opciones de nick diferentes por si alguno ya está ocupado
        </p>
      </div>
      <div className="tm-reg-nicks-list">
        {[0, 1, 2].map((i) => (
          <div key={i} className="tm-reg-nicks-row">
            <span className="tm-reg-nicks-badge" aria-hidden>{i + 1}</span>
            <input
              type="text"
              className="tm-registro-input tm-reg-nicks-input"
              value={values[i] || ''}
              onChange={(e) => setAt(i, e.target.value)}
              placeholder={placeholders[i]}
              autoComplete="off"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default NicknameOptions;
